import Swiper, { Navigation, Pagination, Scrollbar, Zoom, Mousewheel, Thumbs, Manipulation, Autoplay } from "swiper";

// Swiper Class
const SWIPER_MODULES = [Navigation, Pagination, Scrollbar, Zoom, Mousewheel, Thumbs, Manipulation, Autoplay];
Swiper.use(SWIPER_MODULES);

export default Swiper;
